import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  withRouter,
  RouteComponentProps,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { ShiftInformation } from "./components/ShiftInformation";
import { PharmacyInformation } from "./components/PharmacyInformation";
import { DentalShiftInfo } from './components/DentalShiftInfo';
import { ShiftProps } from "../../interfacesProps/ShiftProps";
import { pageStyle, containerStyle, ColumnStyle } from "../../theme/ComponentTheme";
import { BillInformation } from "./components/BillInformation";
import { WorkerInformation } from "./components/WorkerInformation";
import {
  ApprovalModeEnum,
  getEffectiveRoleName,
  roleNameEnum,
  RoutePathConstant,
} from "../../util/Common";
import { ShiftService } from "../../api/ShiftService";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { ShiftRelatedConstants } from "../../util/ShiftConstants";
import { getRequestPaymentDisableInfo } from "../../util/RequestPaymentReminder";
import { isPaymentInfoNotApplicable } from "../../util/PaymentInfoAvailability";
import { dateOnlyToUtcIso } from "../../util/DatetimeUtils";
import { Colors, FontSize, Spacing } from "../../theme/Theme";
import { RBCardView } from "../../components/RBCardView";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { RBSnackbar } from "../../components/RBSnackbar";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { AuthService } from "../../api/AuthService";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { RBContext } from '../../components/RBContext';
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { IndustryModeEnum } from "../../api/constants";
import { DentalPracticeInfo } from "./components/DentalPracticeInfo";
import { ShiftNetworkInformation } from "./components/ShiftNetworkInformation";
import { RBNetworkCancelAlert } from "../../components/RBNetworkCancelAlert";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { RBTextField } from "../../components/RBTextField";
import ShiftPaymentModal from "../../components/ShiftPaymentModal";
import { formatWorkerType } from "../../util/FormattingService";
import { PharmacyService } from "../../api/PharmacyService";
import { RBActiveShiftCancelModal } from "../../components/RBActiveShiftCancelModal";
import { Box, OutlinedInput, Typography } from "@material-ui/core";
import { findUserShiftRequest } from "../../util/ShiftToRequest";
import { ShiftInformationWorker } from "./components/ShiftInformationWorker";
import { DentalShiftInfoWorker } from "./components/DentalShiftInfoWorker";
import { useStripePaymentRefresh } from "../../util/useStripePaymentRefresh";
import { shouldShowShiftRating } from "../../util/shiftRating";
import ShiftRatingInformation from "./components/ShiftRatingInformation";
import {
  ShiftListUiStateCarrier,
  withShiftListUiState,
} from "../../util/shiftListUiState";
import { AccountInfoContext } from "../../components/AccountInfoContext";


interface ShiftDetailPageProps { }

type ShiftDetailLocationState = ShiftListUiStateCarrier & {
  shiftId?: string;
  scrollY?: number;
};

export const ShiftDetailPage: React.FC<ShiftDetailPageProps> = ({
  ...props
}) => {
  // const { shiftData, roleName } = props;
  const [shiftData, setShiftDetail] = useState<ShiftProps>({});
  const [roleName, _] = useState<string>(AuthService.getRoleName());
  const [isAlertShowing, setShiftAlertShowing] = useState(false);
  const [shiftAlertInfo, setShiftAlertInfo] = useState<AlertInfoProps>({});
  console.log('shiftData', shiftData)

  const [shiftNetworkAlertInfo, setShiftNetworkAlertInfo] = useState<AlertInfoProps>({});
  const [isNetworkAlertShowing, setShiftNetworkAlertShowing] = useState(false);



  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isPaymentSaving, setIsPaymentSaving] = useState(false);
  const [isRequestPaymentLoading, setIsRequestPaymentLoading] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [paymentShift, setPaymentShift] = useState<ShiftProps | null>(null);
  const [stripeRefreshTrigger, setStripeRefreshTrigger] = useState(0);

  // Hook for auto-refresh after Stripe payment
  const { startStripePaymentWatch } = useStripePaymentRefresh({
    shiftId: paymentShift?.id as string,
    onRefresh: () => setStripeRefreshTrigger(prev => prev + 1),
  });

  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const [shiftCancelable, setShiftCancelable] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const history = useHistory();
  const location = useLocation<ShiftDetailLocationState>();
  const match = useRouteMatch<{ shiftId: string }>();
  const { industryMode, primaryColor, secondaryColor } = useContext(RBContext);
  const [account, setAccount] = useState<any>([]);
  const effectiveRoleName = getEffectiveRoleName(account, roleName);
  const [networkAdminInfo, setNetworkAdminInfo] = useState<any>([]);
  const [shiftNetworkMail, setShiftNetworkMail] = useState('');
  const [shiftNetworkPhn, setShiftNetworkPhn] = useState('');

  const [blockUserDialogVisible, setBlockUserDialogVisible] = useState(false);
  const [blockUserComment, setBlockUserComment] = useState('');
  const [reason, setReason] = useState('');
  const [cancelLoading, setCancelLoading] = useState(false);
  const [currentPharmacy, setCurrentPharmacy] = useState<any>(null);

  //  const [isAssigned,setIsAssigned] = useState();

  // Initial fetch on mount and when shift changes
  useEffect(() => {
    fetchData();
  }, [match.params.shiftId]);

  // Refresh when Stripe payment is completed (user returns from Stripe)
  useEffect(() => {
    if (stripeRefreshTrigger > 0) {
      console.log("ShiftDetailPage: Stripe payment refresh triggered");
      fetchData();
    }
  }, [stripeRefreshTrigger]);

  // Store account information from context to local state for use in this component
  const { accountInformation } = useContext(AccountInfoContext);
  useEffect(() => {
    setAccount(accountInformation);
  }, [accountInformation]);

  const fetchData = async () => {
    try {
      setIsPageLoading(true);
      const shiftDetailData = await ShiftService.getShiftDetailByShiftId(
        match.params.shiftId
      );

      // let pharmaNetworkId = shiftDetailData.pharmacy ?  shiftDetailData.pharmacy.networkId : null;
      // if(pharmaNetworkId === null){
      //   const fetchedShift = await ShiftService.getShift(shiftDetailData.id);
      //   pharmaNetworkId = fetchedShift.pharmacy.networkId;
      // }

      await fetchNetworkInfo(shiftDetailData.pharmacy.networkId)
      const shiftNetworkData = await ShiftService.getNetworkDetails(shiftDetailData.pharmacy.networkId)
      console.log('info', shiftNetworkData)
      setShiftNetworkMail(shiftNetworkData.contactEmail)
      setShiftNetworkPhn(shiftNetworkData.contactPhone)



      const rbShiftPreference = await AuthService.getRBShiftPreference();
      if (typeof rbShiftPreference.shiftCancelable !== "undefined") {
        setShiftCancelable(rbShiftPreference.shiftCancelable);
        console.log(
          "ShiftDetailController rbShiftPreference ",
          rbShiftPreference
        );
      }
      setShiftDetail(shiftDetailData);
      setIsPageLoading(false);
    } catch (err) {
      const e: any = err;
      setSubmitErrorMessage(e?.response ? e.response.data : e?.message);
    } finally {
    }
  };

  console.log('shiftData from shiftDetailPage', shiftData)
  console.log('user account from shiftDetailPage', account)

  const fetchNetworkInfo = async (networkId: string) => {
    const networkInfo = await ShiftService.getNetworkAdminInfo(networkId);
    setNetworkAdminInfo(networkInfo)
  }

  const navigateBackToShiftList = () => {
    const shiftListUiState = location.state?.shiftListUiState;

    if (typeof shiftListUiState !== "undefined") {
      history.push(RoutePathConstant.Shifts, withShiftListUiState(shiftListUiState));
      return;
    }

    history.push(RoutePathConstant.Shifts);
  };

  const openPaymentModal = (shift: ShiftProps) => {
    setPaymentShift(shift);
    setPaymentModalVisible(true);
  };

  const closePaymentModal = () => {
    setPaymentModalVisible(false);
    setPaymentShift(null);
  };

  const formatPaymentErrorMessage = (err: any): string => {
    const payload = err?.response?.data;

    if (typeof payload?.message === "string") return payload.message;
    if (typeof payload?.error === "string") return payload.error;

    if (Array.isArray(payload?.message)) {
      const firstMessage = payload.message[0];
      if (typeof firstMessage === "string") {
        return firstMessage;
      }
      if (firstMessage && typeof firstMessage === "object") {
        const constraints = (firstMessage as any).constraints;
        if (constraints && typeof constraints === "object") {
          const values = Object.values(constraints).filter(
            (value) => typeof value === "string"
          ) as string[];
          if (values.length > 0) {
            return values[0];
          }
        }
      }
      return "Unable to process payment at this time.";
    }

    if (typeof payload === "string") return payload;
    if (typeof err?.message === "string") return err.message;
    return "Unable to process payment at this time.";
  };

  const handleCreatePayment = async (payload: any) => {
    try {
      setIsPaymentSaving(true);
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        setIsPaymentSaving(false);
        return;
      }

      const paymentDateIso = dateOnlyToUtcIso(payload.paymentDate);
      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: paymentDateIso,
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.createShiftPayment(body);
      setPaymentModalVisible(false);
      setShiftAlertInfo({
        title: "Success",
        message: "Shift payment details saved.",
        buttons: [
          <RBButton
            key={"okPayment"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
      // refresh shift details to pick up paymentData
      await fetchData();
      // NotificationService.publish(NotificationServiceTopic.ShiftChanged, paymentShift.id);
    } catch (err) {
      const e: any = err;
      setShiftAlertInfo({
        title: "Error",
        message: formatPaymentErrorMessage(e),
        buttons: [
          <RBButton
            key={"okErrPayment"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    } finally {
      setIsPaymentSaving(false);
    }
  };

  const handleUpdatePayment = async (payload: any) => {
    try {
      setIsPaymentSaving(true);
      if (!paymentShift || !paymentShift.id) {
        throw new Error("No shift selected for payment update");
      }
      const selectedMethod = String(payload?.paymentMethod || "").trim().toLowerCase();

      if (selectedMethod === "stripe") {
        const response = await ShiftService.createShiftStripePaymentLink(paymentShift.id as string);
        const paymentLink = response?.paymentLink || response?.stripePaymentLink || response?.url;
        if (!paymentLink) {
          throw new Error("Stripe payment link was not returned.");
        }
        window.open(paymentLink, "_blank", "noopener,noreferrer");
        // Start watching for payment completion (auto-refresh on focus/polling)
        startStripePaymentWatch();
        // Close modal and return early for Stripe payments
        setPaymentModalVisible(false);
        setIsPaymentSaving(false);
        return;
      }

      const paymentDateIso = dateOnlyToUtcIso(payload.paymentDate);
      const body = {
        shiftId: paymentShift.id,
        status: "paid",
        paymentDate: paymentDateIso,
        paymentMethod: payload.paymentMethod,
        paymentMethodOther: payload.paymentOtherDescription || "",
        paymentReference: payload.paymentReference || "",
      };
      await ShiftService.updateShiftPayment(paymentShift.id as string, body);
      setPaymentModalVisible(false);
      setShiftAlertInfo({
        title: "Success",
        message: "Shift payment details updated.",
        buttons: [
          <RBButton
            key={"okPaymentUpdate"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
      await fetchData();
      // NotificationService.publish(NotificationServiceTopic.ShiftChanged, paymentShift.id);
    } catch (err) {
      const e: any = err;
      setShiftAlertInfo({
        title: "Error",
        message: formatPaymentErrorMessage(e),
        buttons: [
          <RBButton
            key={"okErrPaymentUpdate"}
            onClick={() => setShiftAlertShowing(false)}
            buttonBackgroundColor={secondaryColor}
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    } finally {
      setIsPaymentSaving(false);
    }
  };
  // when there is a need to talk to API
  const onActionRelatedToAPI = async (buttonText: string) => {
    try {
      setShiftAlertShowing(false);
      setIsButtonLoading(true);

      if (effectiveRoleName === roleNameEnum.owner) {
        switch (buttonText) {
          case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
            await ShiftService.cancelShiftById(shiftData.id);
            //await new Promise((resolve) => setTimeout(resolve, 3000));
            navigateBackToShiftList()
            NotificationService.publish(
              NotificationServiceTopic.ShiftChanged,
              shiftData.id
            );
            break;
          }
        }
      } else if (effectiveRoleName === roleNameEnum.pharmacist) {
        switch (buttonText) {
          case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
            // await new Promise((resolve) => setTimeout(resolve, 3000));
            await ShiftService.cancelShiftById(shiftData.id);
            navigateBackToShiftList()
            break;
          }
          case ShiftRelatedConstants.ShiftButtonText.WithdrawShift: {
            await ShiftService.withdrawRequestedShiftById(shiftData.id);
            navigateBackToShiftList()
            break;
          }
        }
      }
      //history.goBack();
    } catch (err) {
      const e: any = err;
      setSubmitErrorMessage(e?.response ? e.response.data : e?.message);
      console.log("onActionRelatedToAPI error ", e);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const doAction = (buttonText: string) => {
    if (effectiveRoleName === roleNameEnum.owner) {
      switch (buttonText) {
        case ShiftRelatedConstants.ShiftButtonText.ViewApplications:
          history.push(RoutePathConstant.ViewApplicant + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.RateShift:
          history.push(RoutePathConstant.ShiftSurvey + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.ConfirmHours:
          history.push(RoutePathConstant.ShiftConfirmHour + shiftData.id);
          break;
        case ShiftRelatedConstants.ShiftButtonText.EditShift:
          if (industryMode === IndustryModeEnum.Pharmaceutical) {
            history.push(RoutePathConstant.EditShift + shiftData.id);
          }
          else {
            history.push(RoutePathConstant.EditeDentalShift + shiftData.id);
          }

          break;
        case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
          const cancellationFee = ShiftService.getCancellationFee(shiftData);
          let message = "Are you sure you wish to cancel this shift?";
          if (cancellationFee) {
            const feeAsDollars = `$${(cancellationFee / 100).toFixed(2)}`;
            message = `By cancelling at this point you agree to pay the amount of ${feeAsDollars} as a penalty.`;
          }
          if (shiftCancelable || !shiftData.flags.isAssigned) {
            setShiftAlertInfo({
              title: "Cancel Shift",
              message: "",
              buttons: [
                <RBButton
                  key={"confirm"}
                  onClick={async () => {
                    await onActionRelatedToAPI(
                      ShiftRelatedConstants.ShiftButtonText.CancelShift
                    );
                  }}
                  buttonBackgroundColor={primaryColor}
                  //color="primary"
                  text="Yes"
                />,
                <RBButton
                  key={"cancel"}
                  buttonType={RBButtonType.cancel}
                  onClick={() => {
                    setShiftAlertShowing(false);
                  }}
                  text="No"
                />,

              ],
            });
            setShiftAlertShowing(true);
          } else {

            setShiftNetworkAlertInfo({
              title: "\n",
              phone: shiftNetworkPhn,
              email: shiftNetworkMail,
              buttons: [
                <RBButton
                  key={"ok"}
                  onClick={() => {
                    setShiftNetworkAlertShowing(false);
                  }}
                  //color="primary"
                  text="Close"
                  buttonBackgroundColor={secondaryColor}
                />,
              ],
            });
            setShiftNetworkAlertShowing(true)
          }

          break;
        }
      }
    } else if (effectiveRoleName === roleNameEnum.pharmacist) {
      switch (buttonText) {
        case ShiftRelatedConstants.ShiftButtonText.ConfirmHours:
          history.push(
            RoutePathConstant.ShiftConfirmHour + shiftData.id,
            withShiftListUiState(location.state?.shiftListUiState)
          );
          break;
        case ShiftRelatedConstants.ShiftButtonText.CancelShift: {
          const cancellationFee = ShiftService.getCancellationFee(shiftData);
          let message = "Are you sure you wish to cancel this shift?";
          if (cancellationFee) {
            const feeAsDollars = `$${(cancellationFee / 100).toFixed(2)}`;
            message = `By cancelling at this point you agree to pay the amount of ${feeAsDollars} as a penalty.`;
          }
          if (shiftCancelable) {
            setShiftAlertInfo({
              title: "Cancel Shift",
              message: message,
              buttons: [
                <RBButton
                  key={"cancel"}
                  buttonType={RBButtonType.cancel}
                  onClick={() => {
                    setShiftAlertShowing(false);
                  }}
                  text="No"
                />,
                <RBButton
                  key={"confirm"}
                  onClick={async () => {
                    await onActionRelatedToAPI(
                      ShiftRelatedConstants.ShiftButtonText.CancelShift
                    );
                  }}
                  buttonBackgroundColor={primaryColor}
                  // color="primary"
                  text="Yes"
                />,
              ],
            });
            setShiftAlertShowing(true);
          } else {
            setShiftNetworkAlertInfo({
              title: "\n",
              phone: shiftNetworkPhn,
              email: shiftNetworkMail,
              buttons: [
                <RBButton
                  key={"ok"}
                  onClick={() => {
                    setShiftNetworkAlertShowing(false);
                  }}
                  //color="primary"
                  text="Close"
                  buttonBackgroundColor={secondaryColor}
                />,
              ],
            });
            setShiftNetworkAlertShowing(true)
          }

          break;
        }
        case ShiftRelatedConstants.ShiftButtonText.WithdrawShift: {
          setShiftAlertInfo({
            title: "Withdraw from Shift",
            message: "Are you sure you wish to withdraw from this shift?",
            buttons: [
              <RBButton
                key={"confirm"}
                onClick={async () => {
                  await onActionRelatedToAPI(
                    ShiftRelatedConstants.ShiftButtonText.WithdrawShift
                  );
                }}
                buttonBackgroundColor={primaryColor}
                text="Yes"
              />,
              <RBButton
                key={"cancel"}
                buttonType={RBButtonType.cancel}
                onClick={() => {
                  setShiftAlertShowing(false);
                }}
                text="No"
              />,

            ],
          });
          setShiftAlertShowing(true);
          break;
        }
      }
    }
  };

  const renderPharmacyShiftDetailLayout = (
    shiftData: ShiftProps,
    roleName: string,
    doAction: (buttonText: string) => void
  ) => {
    const isCompletionAcknowledged = shiftData.flags
      ? shiftData.flags.isCompletionAcknowledged
      : false;
    return (
      <>
        {renderShiftStatus(shiftData, roleName)}
        {isCompletionAcknowledged || (shiftData.flags.isCancelled && shiftData.isCancellationFeeApplied) ? (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <BillInformation account={account} shiftData={shiftData} industryMode={industryMode} roleName={roleName} />
                <ShiftInformation shiftData={shiftData} />
                <WorkerInformation shiftData={shiftData} />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        ) : (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <WorkerInformation shiftData={shiftData} />
                <ShiftInformation shiftData={shiftData} />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        )}
        {renderActionsForOwner(shiftData, doAction, roleName)}
      </>
    );
  };

  const onClose = () => {
    setBlockUserDialogVisible(false);
  }
  const onBlockUser = async (shiftData: any) => {
    try {
      await AuthService.blockUser({
        comment: blockUserComment.length > 0 ? blockUserComment : null,
        shiftId: shiftData.id,
      });
      let payload = {};
      if (roleName === roleNameEnum.owner) {
        payload = {
          id: shiftData.id,
          locationFeedbackGiven: true
        }
      } else {
        payload = {
          id: shiftData.id,
          workerFeedbackGiven: true
        }
      }
      await PharmacyService.updateShiftFeedback(payload)
    } catch (error) {
      console.log('onBlockUser ', error);
    }

    setBlockUserDialogVisible(false);
    history.goBack();
  };

  const onShiftFeedback = async (shiftData: any) => {
    try {
      let payload = {};
      if (roleName === roleNameEnum.owner) {
        payload = {
          id: shiftData.id,
          locationFeedbackGiven: true
        }
      } else {
        payload = {
          id: shiftData.id,
          workerFeedbackGiven: true
        }
      }
      await PharmacyService.updateShiftFeedback(payload)
    } catch (error) {
      console.log('onBlockUser ', error);
    }

    setBlockUserDialogVisible(false);
    history.goBack();
  };

  const renderCreateShiftContent = (shiftData: any) => {
    if (roleName === roleNameEnum.owner) {
      return (
        <div
          style={{
            backgroundColor: Colors.defaultGrey,
            display: "flex",
            flex: 1,
          }}
        >

          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            <div>
              How did the shift go with {shiftData?.pharmacist?.pharmacist?.firstName} {shiftData?.pharmacist?.pharmacist?.lastName}?
              Would you consider hiring this {formatWorkerType(shiftData.pharmacistType)} again?
            </div>
            <br></br>
            <div>
              <RBTextField
                style={{
                  display: "flex",
                  flex: 1,
                  paddingTop: Spacing.small,
                  paddingBottom: Spacing.small,
                }}
                placeholder={"*Please leave a comment if you decide no."}
                value={blockUserComment}
                onChange={(event) => setBlockUserComment(event.target.value)}
                multiline
                rows={3}
                rowsMax={8}
              />
            </div>
            <br></br>
            <div style={{ color: 'red' }}>
              *If you select "No", this {formatWorkerType(shiftData.pharmacistType)} will not be matched with any future shifts/jobs you
              post for this office or any of the other offices on your profile.
            </div>
            <div style={{
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}>
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={isButtonLoading}
                disabled={blockUserComment.length === 0}
                text="No"
                onClick={() => onBlockUser(shiftData)}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={isButtonLoading}
                text="Yes"
                onClick={() => onShiftFeedback(shiftData)}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
            </div>
          </RBCardView>

        </div>
      );
    }
    else {
      return (
        <div
          style={{
            backgroundColor: Colors.defaultGrey,
            display: "flex",
            flex: 1,
          }}
        >

          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            <div>
              How did your shift go with {shiftData.pharmacy.name}? Would you consider
              working at this {shiftData.pharmacy.companyType} again?
            </div>
            <br></br>
            <div>
              <RBTextField
                style={{
                  display: "flex",
                  flex: 1,
                  paddingTop: Spacing.small,
                  paddingBottom: Spacing.small,
                }}
                placeholder={"*Please leave a comment if you decide no."}
                value={blockUserComment}
                onChange={(event) => setBlockUserComment(event.target.value)}
                multiline
                rows={3}
                rowsMax={8}
              />
            </div>
            <br></br>
            <div style={{ color: 'red' }}>
              *If you select "No", you will never match with that {industryMode === IndustryModeEnum.Dentistry ? "dental practice's " : "companies "}
              shifts/jobs again.
            </div>
            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "flex-end",
              }}>
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={isButtonLoading}
                disabled={blockUserComment.length === 0}
                text="No"
                onClick={() => onBlockUser(shiftData)}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={isButtonLoading}
                text="Yes"
                onClick={() => onShiftFeedback(shiftData)}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
            </div>
          </RBCardView>

        </div>
      );
    }
  };
  const renderBlockUserDialog = (shift: any) => {

    return (

      <RBModal
        open={blockUserDialogVisible}
        onClose={onClose}
        modalTitle={"Shift Feedback"
        }
        header={
          <RBEmptyBlock
            style={{
              width: "100%",
              height: Spacing.large,
              backgroundColor: Colors.defaultGrey,
              flexShrink: 0,
            }}
          />
        }
        // actions={this.renderCreateShiftActions()}
        children={
          renderCreateShiftContent(shift)
        }
      />

    );
  };


  const renderDentalShiftDetailLayout = (
    shiftData: ShiftProps,
    roleName: string,
    doAction: (buttonText: string) => void
  ) => {

    const { pharmacy } = shiftData;
    const showPartialInfo =
      shiftData.flags.isCompletionAcknowledged || shiftData.flags.isCancelled;


    const isCompletionAcknowledged = shiftData.flags
      ? shiftData.flags.isCompletionAcknowledged
      : false;
    return (
      <>
        {renderBlockUserDialog(shiftData)}
        {renderShiftStatus(shiftData, roleName)}
        {isCompletionAcknowledged || (shiftData.flags.isCancelled && shiftData.isCancellationFeeApplied) ? (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <BillInformation account={account} shiftData={shiftData} industryMode={industryMode} roleName={roleName} />
                <DentalShiftInfo
                  account={account}
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                  onOpenPaymentModal={openPaymentModal}
                />
                <WorkerInformation shiftData={shiftData} />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        ) : (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <WorkerInformation shiftData={shiftData} />
                <DentalShiftInfo
                  account={account}
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        )}
        {renderActionsForOwner(shiftData, doAction, roleName)}
      </>
    );
  };

  const renderWorkerShiftDetailLayout = (
    shiftData: ShiftProps,
    roleName: string,
    doAction: (buttonText: string) => void,
    account?: any
  ) => {

    // determine the user's request (prefer passed account param)
    const userRequest = findUserShiftRequest(shiftData, account?.id);
    const isRequested = Boolean(
      userRequest &&
      (userRequest.isStartTimeRequested ||
        userRequest.isEndTimeRequested ||
        userRequest.isWageRequested)
    );
    const owner = shiftData.creator ? shiftData.creator.owner : false;
    const showPartialInfo =
      shiftData.flags.isCompletionAcknowledged || shiftData.flags.isCancelled || !owner;
    const isCompletionAcknowledged = shiftData.flags
      ? shiftData.flags.isCompletionAcknowledged
      : false;
    return (
      <>
        {renderShiftStatus(shiftData, roleName, isRequested)}
        {isCompletionAcknowledged ? (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <BillInformation account={account} shiftData={shiftData} industryMode={industryMode} roleName={roleName} />
                <ShiftInformationWorker shiftData={shiftData} />
                <PharmacyInformation
                  shiftData={shiftData}
                  pharmacy={shiftData.pharmacy}
                  owner={owner}
                  showPartialInfo={showPartialInfo}
                  account={account}
                  page="shiftDetails" />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>

            }
          />
        ) : (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <PharmacyInformation shiftData={shiftData}
                  pharmacy={shiftData.pharmacy}
                  owner={owner}
                  showPartialInfo={showPartialInfo}
                  account={account}
                  page="shiftDetails" />

                <ShiftNetworkInformation
                  pharmacy={shiftData.pharmacy}
                  account={account}
                  networkAdminInfo={networkAdminInfo}
                />
                <ShiftInformationWorker shiftData={shiftData} account={account} />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        )}
        {renderActionsForWorker(shiftData, doAction, roleName)}
      </>
    );
  };


  const renderDentalWorkerShiftDetailLayout = (
    shiftData: ShiftProps,
    roleName: string,
    doAction: (buttonText: string) => void,
    account?: any
  ) => {

    const { pharmacy } = shiftData;
    // determine the user's request (prefer passed account param)
    const userRequest = findUserShiftRequest(shiftData, account?.id);
    const isRequested = Boolean(
      userRequest &&
      (userRequest.isStartTimeRequested ||
        userRequest.isEndTimeRequested ||
        userRequest.isWageRequested)
    );
    // when the worker applied the shift but not got confirmed yet, the worker will not be able to view any pharmacy/creator information
    const owner = shiftData.creator ? shiftData.creator.owner : false;
    const ownerEmail = shiftData.creator ? shiftData.creator.email : false;
    const isCompletionAcknowledged = shiftData.flags
      ? shiftData.flags.isCompletionAcknowledged
      : false;
    const showPartialInfo =
      shiftData.flags.isCompletionAcknowledged || shiftData.flags.isCancelled;
    return (
      <>
        {renderBlockUserDialog(shiftData)}
        {renderShiftStatus(shiftData, roleName, isRequested)}
        {isCompletionAcknowledged ? (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <BillInformation account={account} shiftData={shiftData} industryMode={industryMode} roleName={roleName} />
                <DentalShiftInfoWorker
                  account={account}
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                  onOpenPaymentModal={openPaymentModal}
                />
                <DentalPracticeInfo
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                  owner={owner}
                  ownerEmail={ownerEmail}
                  showPartialInfo={showPartialInfo}
                  account={account}
                  page="shiftDetails"
                />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        ) : (
          <RBCardView
            marginVertical={Spacing.large}
            style={{ padding: Spacing.large }}
            children={
              <>
                <DentalPracticeInfo
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                  owner={owner}
                  ownerEmail={ownerEmail}
                  showPartialInfo={showPartialInfo}
                  account={account}
                  page="shiftDetails"
                />

                <ShiftNetworkInformation
                  pharmacy={shiftData.pharmacy}
                  account={account}
                  networkAdminInfo={networkAdminInfo}
                />

                <DentalShiftInfoWorker
                  account={account}
                  pharmacy={pharmacy}
                  shiftData={shiftData}
                  onOpenPaymentModal={openPaymentModal}
                />
                <ShiftRatingInformation shift={shiftData} account={account} />
              </>
            }
          />
        )}
        {renderActionsForWorker(shiftData, doAction, roleName)}
      </>
    );
  };

  const renderShiftStatus = (shiftData: ShiftProps, roleName: string, isRequested: boolean = false) => {

    const isAssigned = shiftData.flags ? shiftData.flags.isAssigned : false;
    let shiftStateStatus = (roleName === roleNameEnum.owner)
      ? ShiftService.getStatusForShiftAsPharmacy(shiftData, roleName, industryMode)
      : ShiftService.getStatusForShiftAsWorker(shiftData, roleName, industryMode)

    if (!shiftData.networkPaid &&
      (shiftStateStatus === ShiftRelatedConstants.ShiftStateText.FeedbackShift)) {
      if (shiftData.flags.isAssigned && shiftData.flags.isCompleted) {

        if (!shiftData.flags.isCompletionAcknowledged) {
          if (shiftData.flags.isDisputed) {
            shiftStateStatus = ShiftRelatedConstants.ShiftStateText.InDispute;
          }
          shiftStateStatus = ShiftRelatedConstants.ShiftStateText.AwaitingHoursConfirmation;
        }
        if (shiftData.flags.isCompletionAcknowledged) {
          shiftStateStatus = ShiftRelatedConstants.ShiftStateText.ShiftCompleted
        }
      }
    }

    return (
      <div
        style={{
          backgroundColor: primaryColor,
          padding: Spacing.large,
        }}
      >
        <div
          style={{
            fontSize: FontSize.large,
            fontWeight: "bold",
            color: "white",
          }}
        >
          {shiftStateStatus}
          {!isAssigned && roleName !== roleNameEnum.owner && isRequested && (
            <span style={{ padding: Spacing.medium, color: "white" }}>
              (Applied with Request)
            </span>)}

        </div>
      </div>
    );
  };

  const renderActionsForWorker = (
    shiftData: ShiftProps,
    doAction: (buttonText: string) => void,
    rolename: string
  ) => {
    const flags = shiftData.flags;
    const shift: any = shiftData;
    const shiftState = ShiftService.getStatusForShiftAsWorker(shiftData, rolename, industryMode);
    const isPaid = !!shiftData.paymentData;
    const applied = true;
    const { isAssigned } = flags;
    const isPast = moment().isAfter(moment(shiftData.endTime));
    const showFeedbackButton =
      (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) &&
      shiftData.workerAutoAcknowledged &&
      !flags.isCancelled &&
      shiftData.workerFeedbackGiven !== true &&
      !flags.isDisputed &&
      (flags.isCompletionAcknowledged || flags.isCompleted);

    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {!isAssigned && !flags.isCancelled && !applied && (
            <RBButton
              isLoading={isButtonLoading}
              //onPress={this.onShiftRequest}
              text="Apply for Shift"
              style={{ flex: 1, padding: 16 }}
              buttonBackgroundColor={primaryColor}
            />
          )}
          {/* Applied but not yet get assign */}
          {!isAssigned && !flags.isCancelled && applied && (
            <RBButton
              isLoading={isButtonLoading}
              onClick={() => {
                doAction(ShiftRelatedConstants.ShiftButtonText.WithdrawShift);
              }}
              text="Withdraw Shift"
              style={{ flex: 1, padding: 16 }}
              buttonBackgroundColor={primaryColor}
            />
          )}
          {isAssigned && isPast && !flags.isCompleted && !flags.isCancelled && (
            <RBButton
              isLoading={isButtonLoading}
              text="Confirm Shift Completion"
              onClick={() => {
                doAction(ShiftRelatedConstants.ShiftButtonText.ConfirmHours);
              }}
              buttonBackgroundColor={primaryColor}
              style={{ flex: 1, padding: 16 }}
            />
          )}

          {isAssigned &&
            !flags.isCancelled &&
            !flags.isPast &&
            shiftState !== ShiftRelatedConstants.ShiftStateText.ActiveShift && shiftData.cancellationRequested === null && (
              ((shiftState === ShiftRelatedConstants.ShiftStateText.ReadyForShift && shiftData.pharmacy?.network?.cancellationRequestFlowEnabled) ?
                <RBButton
                  isLoading={isButtonLoading}
                  text={ShiftRelatedConstants.ShiftButtonText.RequestCancel}
                  style={{ flex: 1, padding: 16 }}
                  onClick={() => {
                    doAction(ShiftRelatedConstants.ShiftButtonText.CancelShift);
                  }}
                  buttonBackgroundColor={primaryColor}
                /> :
                <RBButton
                  isLoading={isButtonLoading}
                  text={ShiftRelatedConstants.ShiftButtonText.CancelShift}
                  style={{ flex: 1, padding: 16 }}
                  onClick={() => {
                    doAction(ShiftRelatedConstants.ShiftButtonText.CancelShift);
                  }}
                  buttonBackgroundColor={primaryColor}
                  disabled={account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                />)
            )}



          {/* {(industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) &&
            shiftData.workerAutoAcknowledged &&
            !flags.isCancelled &&
            shiftData.workerFeedbackGiven !== true &&
            !flags.isDisputed &&
            (flags.isCompletionAcknowledged || flags.isCompleted) && (
              <RBButton
              isLoading={isButtonLoading}
              text="Shift Feedback"
              style={{ flex: 1, padding: 16, background: primaryColor }}*/}
        </div>

        {/* Show dental payment buttons when applicable (they appear above feedback if feedback is present) */}
        {flags.isCompletionAcknowledged && !flags.isCancelled && !isPaid && !shiftData.networkPaid && !isPaymentInfoNotApplicable(shiftData) && (
          <div style={{ display: "flex", flexDirection: "row", marginTop: Spacing.small }}>
            <RBButton
              isLoading={isPaymentSaving}
              text={"Mark Shift as Paid"}
              buttonBackgroundColor={primaryColor}
              onClick={() => {
                openPaymentModal(shiftData);
              }}
              style={{ flex: 1, padding: 16, marginRight: 8 }}
            />

            {(() => {
              const requestPaymentDisableInfo = getRequestPaymentDisableInfo(
                shiftData
              );

              return (
                <div
                  style={{ flex: 1, display: "flex" }}
                  onClick={() => {
                    if (!requestPaymentDisableInfo.disabled) return;

                    setShiftAlertInfo({
                      title: "Request Payment",
                      message:
                        requestPaymentDisableInfo.reason ||
                        "Request Payment is not available yet.",
                      buttons: [
                        <RBButton
                          key={"okRequestPaymentDisabledDetail"}
                          onClick={() => setShiftAlertShowing(false)}
                          buttonBackgroundColor={secondaryColor}
                          text="Ok"
                        />,
                      ],
                    });
                    setShiftAlertShowing(true);
                  }}
                >
                  <RBButton
                    isLoading={isRequestPaymentLoading}
                    disabled={
                      isRequestPaymentLoading || requestPaymentDisableInfo.disabled
                    }
                    text={ShiftRelatedConstants.ShiftButtonText.RequestPayment}
                    buttonBackgroundColor={primaryColor}
                    onClick={() => {
                      if (isRequestPaymentLoading) return;
                      if (requestPaymentDisableInfo.disabled) {
                        return;
                      }

                      const locationName =
                        shiftData?.pharmacy?.displayName ||
                        shiftData?.pharmacy?.name ||
                        (shiftData as any)?.location ||
                        "Location";

                      setShiftAlertInfo({
                        title: "Request Payment",
                        message:
                          "Are you sure you want to send the request payment message?",
                        buttons: [
                          <RBButton
                            key={"confirmRequestWorker"}
                            isLoading={isRequestPaymentLoading}
                            onClick={async () => {
                              try {
                                setShiftAlertShowing(false);
                                setIsRequestPaymentLoading(true);
                                await ShiftService.requestShiftPayment(
                                  shiftData.id as string
                                );

                                // Ensure the button greys out immediately after success,
                                // matching other screens that refresh shift data.
                                setShiftDetail((prev: any) => {
                                  return {
                                    ...prev,
                                    workerPaymentReminderTriggeredAt: new Date().toISOString(),
                                  };
                                });
                                setShiftAlertInfo({
                                  title: "Request Payment",
                                  message: `Your request has been emailed to ${locationName}`,
                                  buttons: [
                                    <RBButton
                                      key={"okRequestPaymentDetail"}
                                      onClick={() => {
                                        setShiftAlertShowing(false);
                                        // history.goBack();
                                      }}
                                      buttonBackgroundColor={secondaryColor}
                                      text="Ok"
                                    />,
                                  ],
                                });
                                setShiftAlertShowing(true);
                                NotificationService.publish(
                                  NotificationServiceTopic.ShiftChanged,
                                  shiftData.id
                                );
                              } catch (err) {
                                const e: any = err;
                                setShiftAlertInfo({
                                  title: "Error",
                                  message:
                                    e?.response?.data?.message ||
                                    e?.response?.data?.error ||
                                    e?.response?.data ||
                                    e?.message,
                                  buttons: [
                                    <RBButton
                                      key={"okErrRequestPaymentDetail"}
                                      onClick={() => setShiftAlertShowing(false)}
                                      buttonBackgroundColor={secondaryColor}
                                      text="Ok"
                                    />,
                                  ],
                                });
                                setShiftAlertShowing(true);
                              } finally {
                                setIsRequestPaymentLoading(false);
                              }
                            }}
                            buttonBackgroundColor={primaryColor}
                            text="Yes"
                          />,
                          <RBButton
                            key={"cancelRequestWorker"}
                            buttonType={RBButtonType.cancel}
                            onClick={() => {
                              setShiftAlertShowing(false);
                              // history.goBack();
                            }}
                            text="Cancel"
                          />,
                        ],
                      });
                      setShiftAlertShowing(true);
                    }}
                    style={{ flex: 1, padding: 16 }}
                  />
                </div>
              );
            })()}
          </div>
        )}

        {shouldShowShiftRating(shift, industryMode, rolename) && (
          <div style={{ display: "flex", flexDirection: "row", marginTop: Spacing.small }}>
            <RBButton
              isLoading={isButtonLoading}
              text="Rate Shift"
              style={{ flex: 1, padding: 16, background: primaryColor }}
              onClick={() => {
                history.push(RoutePathConstant.ShiftSurvey + shiftData.id);
              }}
            />
          </div>
        )}

        {/* Feedback row (full width) */}
        {/* {showFeedbackButton && (
              <div style={{ display: "flex", flexDirection: "row", marginTop: Spacing.small }}>
                <RBButton
                  isLoading={isButtonLoading}
                  text="Shift Feedback"
                  style={{ flex: 1, padding: 16, background: primaryColor }}
                  onClick={() => {
                    setBlockUserDialogVisible(true);
                  }}
                />
              </div>
            )} */}

      </>
    );
  };

  const renderActionsForOwner = (
    shiftData: ShiftProps,
    doAction: (buttonText: string) => void,
    roleName: string
  ) => {
    const flags = shiftData.flags;
    const isPaid = !!shiftData.paymentData;
    const shift: any = shiftData;
    const shiftState = ShiftService.getStatusForShiftAsPharmacy(shiftData, roleName, industryMode);

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {flags.isEditable && (
            <RBButton
              onClick={() => {
                doAction(ShiftRelatedConstants.ShiftButtonText.EditShift);
              }}
              isLoading={isButtonLoading}
              text="Edit Shift"
              style={{
                flex: 1,
                padding: 16,
                marginRight: !flags.isPast && !flags.isCancelled ? 8 : 0,
                background: primaryColor
              }}
              disabled={shiftData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold}
            />
          )}
          {!shiftData.pharmacist && !flags.isCancelled && !flags.isEditable && (
            <RBButton
              isLoading={isButtonLoading}
              text={ShiftRelatedConstants.ShiftButtonText.ViewApplications}
              onClick={() =>
                doAction(ShiftRelatedConstants.ShiftButtonText.ViewApplications)
              }
              style={{
                flex: 1,
                padding: 16,
                marginRight: !flags.isPast && !flags.isCancelled ? 8 : 0,
                background: primaryColor
              }}
              disabled={shiftData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold}
            />
          )}
          {flags.isCompleted && !flags.isCompletionAcknowledged && !flags.isDisputed && (
            <RBButton
              isLoading={isButtonLoading}
              text={ShiftRelatedConstants.ShiftButtonText.ConfirmHours}
              onClick={() =>
                doAction(ShiftRelatedConstants.ShiftButtonText.ConfirmHours)
              }
              style={{
                flex: 1,
                padding: 16,
                marginRight: !flags.isRated ? 8 : 0,
                background: primaryColor,
              }}
            />
          )}

          {!flags.isPast && !flags.isCancelled && shiftState !== ShiftRelatedConstants.ShiftStateText.ActiveShift && shiftData.cancellationRequested === null && (
            (shiftState === ShiftRelatedConstants.ShiftStateText.ReadyForShift && shiftData.pharmacy?.network?.cancellationRequestFlowEnabled) ? (
              <RBButton
                isLoading={isButtonLoading}
                text={ShiftRelatedConstants.ShiftButtonText.RequestCancel}
                style={{ flex: 1, padding: 16, background: primaryColor }}
                onClick={() => {
                  doAction(ShiftRelatedConstants.ShiftButtonText.CancelShift);
                }}
              />
            ) : (
              <RBButton
                isLoading={isButtonLoading}
                text={ShiftRelatedConstants.ShiftButtonText.CancelShift}
                style={{ flex: 1, padding: 16, background: primaryColor }}
                onClick={() => {
                  doAction(ShiftRelatedConstants.ShiftButtonText.CancelShift);
                }}
                disabled={shiftData?.pharmacy?.approval?.approvalMode === ApprovalModeEnum.OnHold}
              />
            )
          )}
          {/* {
        !flags.isCancelled &&
          !flags.isRated &&
          !flags.isDisputed &&
          flags.isCompletionAcknowledged && industryMode === IndustryModeEnum.Pharmaceutical && ( */}


        </div>

        {/* Mark Shift as Paid row (full width above feedback) */}
        {flags.isCompletionAcknowledged && !flags.isCancelled && !isPaid && !shiftData.networkPaid && !isPaymentInfoNotApplicable(shiftData) && (
          <div style={{ display: "flex", flexDirection: "row", marginTop: Spacing.small }}>
            <RBButton
              isLoading={isPaymentSaving}
              text={"Mark Shift as Paid"}
              buttonBackgroundColor={primaryColor}
              onClick={() => {
                openPaymentModal(shiftData);
              }}
              style={{ flex: 1, padding: 16 }}
            />
          </div>
        )}

        {shouldShowShiftRating(shift, industryMode, roleName) && (
          <div style={{ display: "flex", flexDirection: "row", marginTop: Spacing.small }}>
            <RBButton
              isLoading={isButtonLoading}
              text="Rate Shift"
              style={{ flex: 1, padding: 16, background: primaryColor }}
              onClick={() => {
                //doAction(RoutePathConstant.ShiftSurvey + shiftData.id);
                history.push(RoutePathConstant.ShiftSurvey + shiftData.id);
              }}

            />
          </div>
        )}

        {/* {shiftData?.locationAutoAcknowledged &&
          !flags.isCancelled &&
          shiftData.locationFeedbackGiven !== true &&
          !flags.isDisputed &&
          flags.isCompletionAcknowledged &&
          flags.isCompletionAcknowledged && (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) && (
            <RBButton
              isLoading={isButtonLoading}
              text="Shift Feedback"
              style={{ flex: 1, padding: 16, background: primaryColor }}
              onClick={() => {
                setBlockUserDialogVisible(true);
              }}
            />
          )} */}


      </div>
    );
  };
  const onCloseModal = () => {
    setReason("")
    setShiftNetworkAlertShowing(false)
  };

  // const onAutoYesClick = async () =>{
  //    try{
  //   setCancelLoading(true)
  //   const payload = {
  //     shiftId:shiftData.id,
  //     userId:account.id,
  //     cancellationRequestReason:reason
  //   }
  //  const cancelDetail = await PharmacyService.requestShiftAutoCancel(payload);
  //   await fetchData();
  //   setCancelLoading(false)
  //   setShiftNetworkAlertShowing(false)
  //   setReason("")
  //   setShiftAlertInfo({
  //     title: "Success!",
  //     message: "The cancellation has been successfully completed.",
  //     buttons: [
  //       <RBButton
  //         key={"ok"}
  //         onClick={async () => {
  //           setShiftAlertShowing(false);
  //         }}
  //         text="Ok"
  //         buttonBackgroundColor={secondaryColor}
  //       />,
  //     ],
  //   });
  //   setShiftAlertShowing(true);
  // }
  //  catch(error){
  //       const message = error.response.data.error;
  //       console.log(error);
  //       setShiftAlertInfo({
  //           title: "An error occurred",
  //           message: `${message}`,
  //           buttons: [

  //               <RBButton
  //               key={"confirm"}
  //               onClick={async () => {
  //                   setShiftAlertShowing(false);
  //                   history.push("/dashboard");
  //               }}
  //               buttonBackgroundColor={primaryColor}
  //               color="primary"
  //               text="Ok"
  //               />,
  //           ],
  //           });
  //           setShiftAlertShowing(true);
  //     }
  //     finally{
  //       setCancelLoading(false);
  //     }
  // }


  const onYesClick = async (isEligibleForImmediateCancel = false) => {
    try {
      setCancelLoading(true)
      const payload = {
        shiftId: shiftData.id,
        userId: account.id,
        cancellationRequestReason: reason
      }
      const cancelDetail = await PharmacyService.requestShiftCancel(payload);
      await fetchData();
      setCancelLoading(false)
      setShiftNetworkAlertShowing(false)
      setReason("")
      let message = isEligibleForImmediateCancel === true ? 'The cancellation has been successfully completed.' : 'Request sent successfully!';
      setShiftAlertInfo({
        title: "Success!",
        message,
        buttons: [
          <RBButton
            key={"ok"}
            onClick={async () => {
              setShiftAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setShiftAlertShowing(true);
    }
    catch (err) {
      const error: any = err;
      const message = (error && error.response && error.response.data && error.response.data.error) || (error && error.message);
      console.log(error);
      setShiftAlertInfo({
        title: "An error occurred",
        message: `${message}`,
        buttons: [

          <RBButton
            key={"confirm"}
            onClick={async () => {
              setShiftAlertShowing(false);
              history.push("/dashboard");
            }}
            buttonBackgroundColor={primaryColor}
            color="primary"
            text="Ok"
          />,
        ],
      });
      setShiftAlertShowing(true);
    }
    finally {
      setCancelLoading(false);
    }
  }

  const renderAutoCancelContent = () => {
    const cancelAutoRemove = shiftData?.pharmacy?.shiftCancelAutoRemove;
    const cancelAutoRemoveDays = shiftData?.pharmacy?.shiftCancelAutoRemoveDays;

    const shiftDate: any = new Date(shiftData?.officialStartTime);
    const today = new Date();

    // Convert both to start of day (to avoid time-of-day issues)
    const startOfShift: any = new Date(shiftDate.getFullYear(), shiftDate.getMonth(), shiftDate.getDate());
    const startOfToday: any = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Difference in milliseconds
    const diffMs = startOfShift - startOfToday;

    // Convert to days
    const dateDiffInDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    const dayLabel = dateDiffInDays === 1 ? 'day' : 'days';

    const isEligibleForImmediateCancel = dateDiffInDays >= cancelAutoRemoveDays;
    const isOwner = account.roleName === "owner";

    const getCancelMessage = () => {
      if (!cancelAutoRemove) return null;

      // CASE 1 & 3: >= CancelAutoRemoveDays
      if (isEligibleForImmediateCancel) {
        return (
          <>
            <Typography style={{ fontSize: 14 }}>
              This shift is more than {dateDiffInDays} {dayLabel} and is
              eligible for immediate cancellation.
            </Typography>

            <Typography style={{ fontSize: 14, marginTop: 8 }}>
              (Without requiring review by the Network Admin.)
            </Typography>

            <br />

            <Typography style={{ fontSize: 14 }}>
              Please share a reason for cancellation – this will be shared with the
              Network Admin and{" "}
              {isOwner ? shiftData?.pharmacist?.pharmacist?.firstName + " " + shiftData?.pharmacist?.pharmacist?.lastName : "Location Owner"}.
            </Typography>
          </>
        );
      }

      // CASE 2 & 4: < CancelAutoRemoveDays
      else {
        return (
          <>
            <Typography style={{ fontSize: 14 }}>
              This shift is less than {dateDiffInDays} days. Your
              cancellation request will be reviewed by the Network Admin. They may
              contact you for additional details.
            </Typography>

            <br />

            <Typography style={{ fontSize: 14 }}>
              Please share a reason for cancellation – this will be shared with the
              Network Admin and{" "}
              {isOwner ? shiftData?.pharmacist?.pharmacist?.firstName + " " + shiftData?.pharmacist?.pharmacist?.lastName : "Location Owner"}.
            </Typography>
          </>
        );
      }
    };


    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
        }}
      >

        <RBCardView
          style={{
            flex: 1,
            marginLeft: Spacing.large,
            marginRight: Spacing.large,
            marginBottom: Spacing.smallest,
            paddingLeft: Spacing.large,
            paddingTop: Spacing.large,
            paddingRight: Spacing.large,
            paddingBottom: Spacing.large,
          }}
        >
          {getCancelMessage()}

          <br></br>

          <div
            style={{
              border: "1px solid #0b0b0bff",
              borderRadius: 8,
              padding: 12,
              marginTop: 12,
              backgroundColor: "white",
            }}
          >
            <Typography style={{ fontSize: 14, marginBottom: 8 }}>Reason:</Typography>

            <Box position="relative" style={{ marginBottom: 10 }}>
              <RBTextField
                style={{
                  display: "flex",
                  flex: 1,
                  paddingTop: Spacing.small,
                  paddingBottom: Spacing.small,
                  fontSize: 14,
                }}
                value={reason}
                onChange={(event) => setReason(event.target.value)}
                multiline
                rows={3}
                rowsMax={8}
              />

              {!reason && (
                <Box
                  style={{
                    position: "absolute",
                    top: 12,
                    left: 12,
                    pointerEvents: "none",
                    color: "rgba(0,0,0,0.6)",
                    fontSize: 14,
                  }}
                >
                  * Please share your reason. It will be visible to the
                  <strong> Network Admin </strong> and the{" "}
                  <strong>
                    {effectiveRoleName === roleNameEnum.owner
                      ? formatWorkerType(shiftData.pharmacistType)
                      : "Location Owner"}
                  </strong>.
                </Box>
              )}
            </Box>
          </div>


          <br></br>

          <div style={{
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
          }}>
            <RBButton
              buttonBackgroundColor={primaryColor}
              disabled={reason === ''}
              isLoading={cancelLoading}
              text="Yes"
              onClick={() => {
                onYesClick(isEligibleForImmediateCancel)
              }}
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
            />
            <RBButton
              buttonBackgroundColor={secondaryColor}
              text="No"
              onClick={() => {
                setReason('')
                setShiftNetworkAlertShowing(false)
              }}
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
            />
          </div>
        </RBCardView>

      </div>
    );
  };

  const renderCancelContent = () => {
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
        }}
      >

        <RBCardView
          style={{
            flex: 1,
            marginLeft: Spacing.large,
            marginRight: Spacing.large,
            marginBottom: Spacing.smallest,
            paddingLeft: Spacing.large,
            paddingTop: Spacing.large,
            paddingRight: Spacing.large,
            paddingBottom: Spacing.large,
          }}
        >
          {
            effectiveRoleName === roleNameEnum.owner ?
              <>
                <div>
                  Are you sure you want to submit a request to cancel?
                </div>
                <br />
                <div>
                  Please review <b>Shift Agreement</b> for cancellation policy.
                </div>
                <br />
                <div>
                  If this is a short-notice request, please remember to contact the {formatWorkerType(shiftData.pharmacistType)} to inform them.
                </div>
                <br />
                <div>
                  Their information is in the shift details.
                </div>
                <br />
              </> :
              <>
                <div>
                  Are you sure you want to submit a request to cancel?
                </div>
                <br />
                <div>
                  Please review <b>Shift Agreement</b> for cancellation policy.
                </div>
                <br />
                <div>
                  If this is a short-notice request, please remember to contact the {shiftData?.pharmacy?.companyType !== null ? shiftData?.pharmacy?.companyType : 'Pharmacy'} to inform them.
                </div>
                <br />
                <div>
                  Their information is in the shift details.
                </div>
              </>
          }
          <br></br>

          <div style={{ ...ColumnStyle, alignItems: "center" }}>
            <Typography style={{ display: "flex", flex: 1, fontSize: 14 }}>Reason:</Typography>
          </div>
          <Box position="relative">
            <RBTextField
              style={{
                display: "flex",
                flex: 1,
                paddingTop: Spacing.small,
                paddingBottom: Spacing.small,
                fontSize: 14
              }}
              value={reason}
              onChange={(event) => setReason(event.target.value)}
              multiline
              rows={3}
              rowsMax={8}
            />
            {!reason && (
              <Box
                style={{
                  position: "absolute",
                  top: 12,
                  left: 12,
                  pointerEvents: "none",
                  color: "rgba(0,0,0,0.6)",
                  fontSize: 14,
                }}
              >
                * Please share your reason. It will be visible to the
                <strong> Network Admin </strong> and the <strong>{effectiveRoleName === roleNameEnum.owner ? formatWorkerType(shiftData.pharmacistType) : shiftData?.pharmacy?.companyType !== null ? shiftData?.pharmacy?.companyType : 'Pharmacy'}</strong>.

              </Box>
            )}
          </Box>

          <br></br>

          <div style={{
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
          }}>
            <RBButton
              buttonBackgroundColor={primaryColor}
              disabled={reason === ''}
              isLoading={cancelLoading}
              text="Yes"
              onClick={() => {
                onYesClick()
              }}
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
            />
            <RBButton
              buttonBackgroundColor={secondaryColor}
              text="No"
              onClick={() => {
                setReason('')
                setShiftNetworkAlertShowing(false)
              }}
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
            />
          </div>
        </RBCardView>

      </div>
    );
  };

  return (
    <div style={{ ...pageStyle }} className="paddingHorizontal paddingVertical">
      <RBAlert
        show={isAlertShowing}
        alertTitle={shiftAlertInfo.title}
        alertMessage={shiftAlertInfo.message}
        buttons={shiftAlertInfo.buttons}
      />

      {shiftData.pharmacy?.network?.cancellationRequestFlowEnabled ?
        <RBActiveShiftCancelModal
          open={isNetworkAlertShowing}
          onClose={onCloseModal}
          modalTitle={""}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          // actions={this.renderCreateShiftActions()}
          children={
            shiftData?.pharmacy?.shiftCancelAutoRemove ? renderAutoCancelContent() : renderCancelContent()
          }
        />
        :
        <RBNetworkCancelAlert
          show={isNetworkAlertShowing}
          alertTitle={shiftNetworkAlertInfo.title}
          phone={shiftNetworkAlertInfo.phone}
          email={shiftNetworkAlertInfo.email}
          buttons={shiftNetworkAlertInfo.buttons}
        />
      }

      <ShiftPaymentModal
        open={paymentModalVisible}
        onClose={closePaymentModal}
        shift={paymentShift}
        existingPayment={paymentShift?.paymentData}
        currentUser={account}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        onCreate={handleCreatePayment}
        onUpdate={handleUpdatePayment}
      />




      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />
      {isPageLoading ? (
        <LoadingIndicator />
      ) : (
        <div style={{ flex: 1 }}>
          {industryMode === IndustryModeEnum.Pharmaceutical ? (effectiveRoleName === roleNameEnum.owner
            ? renderPharmacyShiftDetailLayout(shiftData, effectiveRoleName, doAction)
            : renderWorkerShiftDetailLayout(shiftData, effectiveRoleName, doAction, account))
            : (
              effectiveRoleName === roleNameEnum.owner
                ? renderDentalShiftDetailLayout(shiftData, effectiveRoleName, doAction)
                : renderDentalWorkerShiftDetailLayout(shiftData, effectiveRoleName, doAction, account)
            )}
        </div>
      )}
    </div>
  );
};
